/**
 * Reporting hook for the interface language switch.
 *
 * The switch lives in two places — the header menu and the footer — and both
 * reload the page right after, so the report has to leave before the reload.
 */
export abstract class AbstractLanguageAnalyticsService {
  public abstract trackLanguageChanged(params: { language: string }): void;
}
